import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=998544d0&"
import script from "./Index.vue?vue&type=script&setup=true&lang=js&"
export * from "./Index.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports